import Vue from 'vue'
import Vuex from 'vuex'

const COUNTRIES = require('../assets/json/countries.min.json')

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        countries: COUNTRIES,
    },
    mutations:{},
    actions:{}
})